var H = require("hogan.js");
module.exports = function() { var T = new H.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<iframe");t.b("\n" + i);t.b("    src=\"");t.b(t.v(t.d("file.src",c,p,0)));t.b("\"");t.b("\n" + i);t.b("    width=\"100%\"");t.b("\n" + i);t.b("    style=\"border: none;\" />");t.b("\n");return t.fl(); },partials: {}, subs: {  }}, "<iframe\n    src=\"{{file.src}}\"\n    width=\"100%\"\n    style=\"border: none;\" />\n", H);return T.render.apply(T, arguments); };


//////////////////
// WEBPACK FOOTER
// ../apps/chide/products/smapply/static/sma.common/components/partials/file_previewer/document.mustache
// module id = 2212
// module chunks = 17